import { render } from "./expiring.vue?vue&type=template&id=73d0d13c&scoped=true"
import script from "./expiring.vue?vue&type=script&lang=js"
export * from "./expiring.vue?vue&type=script&lang=js"

import "./expiring.vue?vue&type=style&index=0&id=73d0d13c&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d0d13c"]])

export default __exports__